import * as MarkdownIt from 'markdown-it';
import QueryString from 'query-string'
import * as Moment from 'moment'

export const sortByPriority = (a:{ priority:number }, b:{ priority:number }) => a.priority > b.priority ? 1 : -1;

export const sortByPriorityFields = (a:{fields:{ priority:number }}, b:{fields:{ priority:number }}) => a.fields.priority > b.fields.priority ? 1 : -1;


export const dangerousMarkdownConverted = (markdownString:string) => {
    var md = new MarkdownIt({
        html: true,
        linkify: true,
    });

    return {
        __html: md.render( markdownString )
    }
}


export function getQueryString(){
    console.log("cobrand getQuery"+window.location.href);
    return QueryString.parse(QueryString.extract(window.location.href.replace("/#/", "")));
}


export function prettyDate(contentfulDateString){
    return Moment(contentfulDateString, 'YYYY-MM-DD').format('MMMM Do, YYYY')
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/util.ts